import { List, Record } from 'immutable';
import { schema } from 'normalizr';

export const ProofOfPerformance2PDCReport = new Record({
  id: undefined,
  site: undefined,
  relay: undefined,
  relay_number: undefined,
  schedule: undefined,
  schedule_number: undefined,
  on_duration: undefined,
  report_date: undefined,
  lvt_time: undefined,
  hvt_time: undefined,
  low_voltage_threshold: undefined,
  high_voltage_threshold: undefined,
  passed: undefined,
  watts: undefined,
  watt_hours: undefined,
  input_voltage: undefined,
  on_time: undefined,
  off_time: undefined,
  duty_cycle: undefined,
  alarms: List(),
});

export const proofOfPerformance2PDCReportSchema = new schema.Entity('proofOfPerformance2PDCReports');
